/**
 * @description API 配置
 * config.prefix                : API url前缀
 * config.items[n].key          : 别名，调用此接口时用到，如   testApi.transactionList(API_DATA).then(res=>{})
 * config.items[n].url          : API url
 *                                如果链接以 / 结尾，兼容rest风格（请求参数拼接在路径上）
 *                                带{key}花括号 ， 把value = data[key] 替换到url上{key}里，并删除data.key
 * config.items[n].method:
 * config.items[n].type         : 强制传参方式:query /  body; 为空，按method方式对应默认：get=>query,其它=>body
 * config.items[n].loadingHide  : 请求不显示loading动画; 为空，显示loading
 * config.items[n].loadingMore  : 请求返回结果后，主动延迟几毫米后，再返回response
 * config.items[n].rType  : 请求responseType  取自 {0: 'text', 1: 'json', 2: 'blob', 3: 'buffer'}
 * config.items[n].cType  : 请求headers['Content-type'] 取自 {1: 'application/json', 2: 'multipart/form-data', 3: 'application/x-www-form-urlencoded'}
 *
 * 特殊：（在url的{}替换后） 如果存在data.BjBody ， 则执行 data=data.BjBody
 */
import { generate } from '@/utils/request';
const config = {
  prefix: '',
  items: [
    /**
     * 示例
     *  @organizationId : 0
     */
    {
      key: 'transactionList',
      url: '/iam/skyer/v1/{organizationId}/users/paging',
      method: 'get',
      type: 'query',
      loadingHide: true,
    },
    {
      key: 'getBillJdExcel',
      url: '/simp/v1/0/template/SFIN.BILL_JD/excel',
      method: 'get',
      type: 'query',
      loadingHide: true,
      rType: 2,
    },
  ],
};

export default {
  ...generate(config),
};
